/** Kanban logs */
export const KANBAN_LOG_EMPTY_VALUE = 'Empty value'
